import type { FinishLevel } from "@reno-estimator/core";
import { StepShell } from "../ui/StepShell.js";
import { OptionCard } from "../ui/OptionCard.js";
import type { EstimatorFlow } from "../../state/useEstimatorFlow.js";

const FINISH_OPTIONS: { id: FinishLevel; label: string; description: string }[] = [
  { id: "budget", label: "Budget", description: "Cost-conscious, functional finishes." },
  { id: "standard", label: "Standard", description: "Good quality, widely available materials." },
  { id: "premium", label: "Premium", description: "Upgraded materials and fixtures." },
  { id: "luxury", label: "Luxury", description: "High-end, bespoke materials throughout." }
];

export function Step4FinishLevel({ flow }: { flow: EstimatorFlow }) {
  const finishLevel = (flow.getAnswer("finish_level") as FinishLevel | undefined) ?? "standard";

  return (
    <StepShell title="What level of finish are you considering?" helpText="This affects material and fixture pricing across the whole project." onBack={flow.goBack} onNext={flow.goNext}>
      <div className="option-grid" role="radiogroup" aria-label="Finish level">
        {FINISH_OPTIONS.map((opt) => (
          <OptionCard
            key={opt.id}
            name="finish_level"
            value={opt.id}
            label={opt.label}
            description={opt.description}
            checked={finishLevel === opt.id}
            onChange={(checked) => checked && flow.setAnswer("finish_level", opt.id)}
          />
        ))}
      </div>
    </StepShell>
  );
}
